// TODO: use defined types

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  me: {}
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  token: state => state.token,
  me: state => state.me
}

const actions = {
  AUTH_REQUEST: ({ commit, dispatch }, { $http, user }) => {
    return new Promise(async (resolve, reject) => {
      // The Promise used for router redirect in login
      commit('AUTH_REQUEST')

      const credentials = {
        grant_type: 'password',
        client_id: process.env.VUE_APP_ID,
        username: user.username,
        password: user.password
      }

      $http
        .login(credentials)
        .then(resp => {
          const token = resp.access_token
          const refreshToken = resp.refresh_token
          if (!token) {
            throw new Error('Failed to fetch the token')
          }
          localStorage.setItem('user-token', token) // store the token in localstorage
          localStorage.setItem('refresh-token', refreshToken)

          commit('AUTH_SUCCESS', token)

          dispatch('LOAD_CURRENT_USER', $http)

          resolve(resp)
        })
        .catch(err => {
          commit('AUTH_ERROR', err)
          localStorage.removeItem('user-token') // if the request fails, remove any possible user token if possible
          reject(err)
        })
    })
  },
  AUTH_LOGOUT: ({ commit }) => {
    return new Promise(resolve => {
      commit('AUTH_LOGOUT')
      commit('ME', {})
      localStorage.removeItem('user-token') // clear your user's token from localstorage
      localStorage.removeItem('refresh-token')
      resolve()
    })
  },
  LOAD_CURRENT_USER: async ({ commit }, $userModel) => {
    try {
      const user = await $userModel.getMe()
      commit('ME', user)
    } catch (e) {
      commit('AUTH_ERROR', e)
      localStorage.removeItem('user-token')
      localStorage.removeItem('refresh-token')
    }
  }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded

const mutations = {
  AUTH_REQUEST: state => {
    state.status = 'loading'
  },
  AUTH_SUCCESS: (state, token) => {
    state.status = 'success'
    state.token = token
  },
  AUTH_ERROR: state => {
    state.status = 'error'
  },
  AUTH_LOGOUT: state => {
    state.token = ''
  },
  ME: (state, user) => {
    state.me = user
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
